<template>
    <div class="grafica-avance-fisico">
        <v-container
        fluid>

            <!-- CARD DE GRAFICAS -->
            <v-card
            v-if="!$apollo.loading"

            flat>
            <!-- GRAFICA AVANCE FINANCIERO-->
                <v-card-title primary-title class="justify-center">
                    AVANCE FINANCIERO (PROGRAMADO-ESTIMADO-FISICO)</v-card-title>
                <v-card-text>

                    <line-chart
                    :chart-data="dataGrafica"
                    :options="optionsGrafica"
                    >
                    </line-chart>
                <v-divider class="pa-5"></v-divider>
                <!-- TABLA DE DATOS -->
                <v-simple-table>
                    <template v-slot:default>
                    <thead>
                    <tr class="base4">
                        <th
                            v-for="item in mixPuntosGrafica.ejeXLabels"
                            :key="item"
                            class="text-center">
                            <span
                            class="text-subtitle-1 font-weight-black ">
                              {{ item }}</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr class="base5">
                          <td
                            v-for="(item, index) in mixPuntosGrafica.puntosDelLetra"
                            :key="index"
                            class="text-center">
                            <span class="text-caption font-weight-black">
                              {{ item }} </span>
                          </td>
                        </tr>
                        <tr class="base5">
                          <td
                            v-for="item in mixPuntosGrafica.puntosLetra"
                            :key="item"
                            class="text-center">
                            <span class="text-caption font-weight-black">{{ item }}</span>
                          </td>
                        </tr>
                        <tr>
                        <td
                            v-for="(item,index) in mixPuntosGrafica.programado"
                            :key="index"
                            class="text-right">
                            <v-chip
                            v-if="item===0"
                            class="base3 pr-5 bkground--text font-weight-black">
                            PROG</v-chip>
                            <span v-if="item!==0"
                            class="text-caption">
                              {{ item | currency }}</span></td></tr>
                        <tr>
                        <td
                            v-for="(item,index) in mixPuntosGrafica.financiero"
                            :key="index"
                            class="text-right">
                            <v-chip
                              v-if="item===0"
                              class="error pr-5
                              font-weight-black"
                            >FIN</v-chip>
                            <span v-if="item!==0"
                            class="text-caption">
                              {{ item | currency }}</span></td></tr>
                        <tr>
                        <td
                            v-for="(item,index) in mixPuntosGrafica.fisico"
                            :key="index"
                            class="text-right">
                            <v-chip
                              v-if="item===0"
                              class="success pr-5
                              font-weight-black"
                              >FIS</v-chip>
                            <span v-if="item!==0"
                            class="text-caption">{{ item | currency }}</span></td></tr>
                    </tbody>
                    </template>
                </v-simple-table>
                </v-card-text>

                <!-- GRAFICA AVANCE PORCENTAJE-->
                <v-card-title primary-title class="justify-center mt-10">
                    AVANCE PORCENTUAL (PROGRAMADO-ESTIMADO-FISICO)</v-card-title>
                <v-card-text>
                    <line-chart
                    :chart-data="dataGraficaPorcentajes"
                    :options="optionsGrafica"
                    >
                    </line-chart>
                    <v-divider class="pa-5"></v-divider>
                    <!-- TABLA DE DATOS PORCENTAJE-->
                    <v-simple-table>
                    <template v-slot:default>
                    <thead>
                    <tr class="base4">
                        <th
                            v-for="item in mixPuntosGrafica.ejeXLabels"
                            :key="item"
                            class="text-center">
                            <span
                            class="text-subtitle-1 font-weight-black ">
                              {{ item }}</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                       <tr class="base5">
                          <td
                            v-for="(item,index) in mixPuntosGrafica.puntosDelLetra"
                            :key="index"
                            class="text-center"
                            >
                            <span class="text-caption font-weight-black">
                              {{ item }} </span>
                          </td>
                        </tr>
                        <tr class="base5">
                          <td
                            v-for="item in mixPuntosGrafica.puntosLetra"
                            :key="item"
                            class="text-center">
                            <span class="text-caption font-weight-black">{{ item }}</span>
                          </td>
                        </tr>
                        <tr>
                        <td
                            v-for="(item,index) in mixPuntosGrafica.programadoPorcentaje"
                            :key="index"
                            class="text-right">
                            <v-chip
                            v-if="item===0"
                            class="base3 pr-5 bkground--text font-weight-black">PROG</v-chip>
                            <span v-if="item!==0"
                            class="text-caption">
                              {{ item }} %</span></td></tr>
                        <tr>
                        <td
                            v-for="(item,index) in mixPuntosGrafica.financieroPorcentaje"
                            :key="index"
                            class="text-right">
                            <v-chip
                            v-if="item===0"
                            class="error pr-5 font-weight-black"
                            >FIN</v-chip>
                            <span v-if="item!==0"
                            class="text-caption"  >
                              {{ item }} %</span></td></tr>
                        <tr>
                        <td
                            v-for="(item,index) in mixPuntosGrafica.fisicoPorcentaje"
                            :key="index"
                            class="text-right">
                            <v-chip
                            v-if="item===0"
                            class="success pr-5 font-weight-black">FIS</v-chip>
                            <span v-if="item!==0"
                            class="text-caption">{{ item }} %</span></td></tr>
                    </tbody>
                    </template>
                </v-simple-table>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart';
import mixGraficaAvanceFisico from './mixGraficaAvanceFisico';

export default {
  name: 'GraficaAvanceFisico',
  props: {
    idContrato: {
      type: String,
      required: true,
      default: '',
    },
  },
  components: {
    LineChart,
  },
  mixins: [mixGraficaAvanceFisico],
  data() {
    return {
      optionsGrafica: {
        responsive: true,
        maintainAspectRatio: false,
        plugin: {
          datalabels:
                {
                  formatter: (value) => `1-${value}`,
                  color: '#acf',
                },
        },
        legend: {
          position: 'bottom',
        },

      },
      // dataGrafica: {},
      // dataGraficaPorcentajes: {},
      mostrarGrafica: true,
    };
  },

  // mounted() {
  //   this.getDataGraficas();
  // },

  // watch: {

  //   getEstimaciones() {
  //     this.getDataGraficas();
  //   },

  // },
  computed: {
    dataGrafica() {
      return {
        labels: [...this.mixPuntosGrafica.ejeXLabels],
        datasets: [
          {
            label: 'PROGRAMADO',
            fill: false,
            data: [...this.mixPuntosGrafica.programado],
            borderColor: '#1b1baf',
            tension: 0.1,
            pointRadius: 4,
          },
          {
            label: 'FISICO',
            fill: false,
            data: [...this.mixPuntosGrafica.fisico],
            borderColor: '#43BC82',
            tension: 0.1,
            pointStyle: 'circle',
            pointRadius: 4,
          },
          {
            label: 'FINANCIERO',
            fill: false,
            data: [...this.mixPuntosGrafica.financiero],
            borderColor: '#FA8B00',
            tension: 0.1,
            pointStyle: 'rect',
            pointRadius: 8,

          },

        ],
      };
    },
    dataGraficaPorcentajes() {
      return {
        labels: [...this.mixPuntosGrafica.ejeXLabels],
        datasets: [
          {
            label: 'PROGRAMADO',
            fill: false,
            data: [...this.mixPuntosGrafica.programadoPorcentaje],
            borderColor: '#1b1baf',
            tension: 0.1,
            pointRadius: 4,
          },
          {
            label: 'FISICO',
            fill: false,
            data: [...this.mixPuntosGrafica.fisicoPorcentaje],
            borderColor: '#43BC82',
            tension: 0.1,
            pointStyle: 'circle',
            pointRadius: 4,
          },
          {
            label: 'FINANCIERO',
            fill: false,
            data: [...this.mixPuntosGrafica.financieroPorcentaje],
            borderColor: '#FA8B00',
            tension: 0.1,
            pointStyle: 'rect',
            pointRadius: 8,
          },
        ],
      };
    },
  },
  methods: {
    getDataGraficas() {
      this.dataGrafica = {
        labels: [...this.mixPuntosGrafica.ejeXLabels],
        datasets: [
          {
            label: 'PROGRAMADO',
            fill: false,
            data: [...this.mixPuntosGrafica.programado],
            borderColor: '#1b1baf',
            tension: 0.1,
            pointRadius: 4,
          },
          {
            label: 'FISICO',
            fill: false,
            data: [...this.mixPuntosGrafica.fisico],
            borderColor: '#43BC82',
            tension: 0.1,
            pointStyle: 'circle',
            pointRadius: 4,
          },
          {
            label: 'FINANCIERO',
            fill: false,
            data: [...this.mixPuntosGrafica.financiero],
            borderColor: '#FA8B00',
            tension: 0.1,
            pointStyle: 'rect',
            pointRadius: 8,

          },

        ],
      };
      this.dataGraficaPorcentajes = {
        labels: [...this.mixPuntosGrafica.ejeXLabels],
        datasets: [
          {
            label: 'PROGRAMADO',
            fill: false,
            data: [...this.mixPuntosGrafica.programadoPorcentaje],
            borderColor: '#1b1baf',
            tension: 0.1,
            pointRadius: 4,
          },
          {
            label: 'FISICO',
            fill: false,
            data: [...this.mixPuntosGrafica.fisicoPorcentaje],
            borderColor: '#43BC82',
            tension: 0.1,
            pointStyle: 'circle',
            pointRadius: 4,
          },
          {
            label: 'FINANCIERO',
            fill: false,
            data: [...this.mixPuntosGrafica.financieroPorcentaje],
            borderColor: '#FA8B00',
            tension: 0.1,
            pointStyle: 'rect',
            pointRadius: 8,
          },
        ],
      };
    },
  },

};
</script>
<style lang="scss" scoped>
#line-chart {
  height:200px !important;
}
</style>
